import { Mqtt_Topics_userDataChanges, Mqtt_Topics_packageChanges, Mqtt_Topics_invitationChanges } from "../ThreeDocs.Models/Api/Api.js";
import { ofArray } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg } from "./InvitationsTypes.js";

export function subscribe(uid) {
    return [ofArray([Mqtt_Topics_invitationChanges(uid), Mqtt_Topics_packageChanges(uid), Mqtt_Topics_userDataChanges(uid)]), (Item) => (new Msg(6, [Item]))];
}

